import { createSlotRecipe } from './runtime';

const ratingGroupConfig = {"name":"ratingGroup","slots":["root","label","item","control"],"defaultVariants":{"size":"md"},"variantMap":{"size":["lg","md","sm"]}}

export const ratingGroup = /* @__PURE__ */ createSlotRecipe(ratingGroupConfig)